import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillCrown = () => (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3346 14.6641H4.66797C4.39464 14.6641 4.16797 14.4375 4.16797 14.1641C4.16797 13.8908 4.39464 13.6641 4.66797 13.6641H11.3346C11.608 13.6641 11.8346 13.8908 11.8346 14.1641C11.8346 14.4375 11.608 14.6641 11.3346 14.6641Z"
      fill="#7356E0"
    />
    <path
      d="M13.5707 3.68328L10.9041 5.58995C10.5507 5.84328 10.0441 5.68995 9.89072 5.28328L8.63072 1.92328C8.41739 1.34328 7.59739 1.34328 7.38405 1.92328L6.11739 5.27661C5.96405 5.68995 5.46405 5.84328 5.11072 5.58328L2.44405 3.67661C1.91072 3.30328 1.20405 3.82995 1.42405 4.44995L4.19739 12.2166C4.29072 12.4833 4.54405 12.6566 4.82405 12.6566H11.1774C11.4574 12.6566 11.7107 12.4766 11.8041 12.2166L14.5774 4.44995C14.8041 3.82995 14.0974 3.30328 13.5707 3.68328ZM9.67072 9.83661H6.33739C6.06405 9.83661 5.83739 9.60995 5.83739 9.33661C5.83739 9.06328 6.06405 8.83661 6.33739 8.83661H9.67072C9.94405 8.83661 10.1707 9.06328 10.1707 9.33661C10.1707 9.60995 9.94405 9.83661 9.67072 9.83661Z"
      fill="#7356E0"
    />
  </svg>
)

export default withDefaultStyles(FillCrown)
